import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HostDto, TeamDto, TeamMemberDto } from '@core-http';
import { GetTeamsQueryResult } from './get-teams.query-result';
import { GetTeamDetailsQueryResult } from '../get-team-details/get-team-details.query-result';
import { TeamHost, TeamMember } from '../../../interfaces';
import { MyTeamsDto } from '@orlikfy/api-interfaces';

export class GetTeamsQueryHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  getTeams(): Observable<GetTeamsQueryResult[]> {
    return this.teamsService.getTeams().pipe(
      map((dto: MyTeamsDto) => dto.teams),
      map((teams: TeamDto[]) => teams?.map((team: TeamDto) => this.mapToQueryResult(team)))
    );
  }

  private mapToQueryResult(dto: TeamDto): GetTeamDetailsQueryResult {
    return {
      teamId: dto.teamId,
      teamName: dto.teamName,
      thumbnail: dto.thumbnail,
      host: this.mapHost(dto.host),
      members: dto.members.map((member: TeamMemberDto): TeamMember => this.mapMember(member)),
      memberRole: dto.memberRole,
      invitationToken: dto.invitationToken ?? ''
    };
  }

  private mapHost(host: HostDto): TeamHost {
    return {
      hostId: host.hostId,
      displayName: host.displayName,
      thumbnail: host.thumbnail,
      phone: host.phone
    };
  }

  private mapMember(member: TeamMemberDto): TeamMember {
    return {
      userId: member.userId,
      displayName: member.displayName,
      thumbnail: member.thumbnail ?? '',
      isAutoApproved: member.isAutoApproved,
      memberRole: member.memberRole
    };
  }
}
